import React, { useContext, useEffect, useState } from 'react'
import { Grid, Loader, Dimmer } from 'semantic-ui-react'
import NoteList from './NoteList'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../App/stores/RootStore'
import InfiniteScroll from 'react-infinite-scroller'

const NoteDashboard: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { loadRequestNotes, setPage, page, totalPages } = rootStore.requestNoteStore;
    const { loadRequestReviewNotes, setPageReviewNotes } = rootStore.requestReviewNoteStore;
    const { loadRequestReviewDocumentNotes, setPageReviewDocumentNotes } = rootStore.requestReviewDocumentNoteStore;
    const [loadingNext, setLoadingNext] = useState(false);
    
    //TODO: have notes get loaded again.... somehow?
    const handleGetNext = () => {
        setLoadingNext(true);
        setPage(page + 1);
        setPageReviewNotes(page + 1);
        setPageReviewDocumentNotes(page + 1);
        // loadRequestNotes().then(()=>setLoadingNext(false))
        // loadRequestReviewNotes().then(()=>setLoadingNext(false))
        // loadRequestReviewDocumentNotes().then(()=>setLoadingNext(false))
    }

    useEffect(() => {
        // loadRequestNotes();
        // loadRequestReviewNotes();
        // loadRequestReviewDocumentNotes();
    }, [loadRequestNotes, loadRequestReviewNotes, loadRequestReviewDocumentNotes]);

    return (
        <Grid>
            <Grid.Column style={{ overflowY: "auto", maxHeight: "90vh", width: "100%" }}>
                <InfiniteScroll
                    pageStart={0}
                    loadMore={handleGetNext}
                    hasMore={!loadingNext && page + 1 < totalPages}
                    initialLoad={false}
                >
                    <NoteList />
                </InfiniteScroll>
            </Grid.Column>

            <Grid.Column width={10}>
                <Loader active={loadingNext} />
            </Grid.Column>
        </Grid>
    )
}
export default observer(NoteDashboard);